import React from 'react'
import { NotificationMessage } from '../components/Notifications'
import { NotificationContext } from './index'

interface State {
  notification: NotificationMessage | null
}

export type SetNotification = (notification: NotificationMessage | null) => void

export class NotificationProvider extends React.Component<{}, State> {
  state: State = { notification: null }
  notificationTimer: number | null = null

  render() {
    return (
      <NotificationContext.Provider
        value={{
          notification: this.state.notification,
          setNotification: this.setNotification,
        }}
      >
        {this.props.children}
      </NotificationContext.Provider>
    )
  }

  private setNotification: SetNotification = notification => {
    if (this.notificationTimer) {
      window.clearTimeout(this.notificationTimer)
      this.notificationTimer = null
    }
    if (notification === null) {
      return this.setState({ notification })
    }
    this.setState({ notification }, this.setNotificationTimer)
  }

  private setNotificationTimer = () => {
    this.notificationTimer = window.setTimeout(() => this.setNotification(null), 5000)
  }
}
